module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165415_HDR-removebg-preview-23e44cfc57b9219d10a07696f44b1e76.png";